/**
 * Implements a badge component
 */
import './styles.scss';

interface IBadgeProps {
  variant: 'fill';
  klass: 'grey' | 'red' | 'orange' | 'green';
  text: string;
}

const Badge = ({ variant, klass, text }: IBadgeProps) => (
  <div className={`badge badge__${variant} badge__${variant}--${klass}`}>
    {text}
  </div>
);

export default Badge;
